<template>
    <div class="fi-item" :id="fibsdd.id">

        <router-link :to="linkFi" class="list-item wrap">
            <div class="fa-book-user" v-if="fibsdd.affectation_user === idUser">&nbsp; <span class="font-bold">Fiche affecté</span></div>
            <strong class="numfiche">{{ fibsdd.numero }}</strong>
            <span v-if="fibsdd.ordre_travail != null">- {{ fibsdd.ordre_travail }}</span>
            <br>
            <span class="detenteur" v-if="detenteur">
                {{ detenteur.raison_sociale }} - {{ detenteur.adresse }} - {{ detenteur.code_postal }} - {{ detenteur.ville }}
            </span>
            <span class="detenteur" v-else>
                Chargement en cours...
            </span>
            <br>
            <span class="install" v-if="installation">
                {{ installation.nom }}
            </span>
        </router-link>
        <a v-show="fibsdd.supprimable === true" class="btn del-fi" @click="delFi(fibsdd.id)" href="javascript: void 0">
            <i class="icon icon-delete"></i>
        </a>
    </div>
</template>

<script>
    import Fibsdd from '../../../js/models/Fibsdd'

    export default {
        props: {
            fibsdd: Object,
            detenteur: Object,
            installation: Object,
            idUser: Number
        },
        computed: {

            linkFi() {
                if(this.detenteur != null){
                    return 'fibsdd/' + this.fibsdd.id
                }else{
                    return '#';
                }
            },

        },
        methods: {

            delFi(id) {

                swal({
                    title:'Suppression de fibsdd',
                    text:"Voulez vous vraiment supprimer cette fiche ?",
                    type:'question',
                    showCancelButton: true,
                    cancelButtonText: 'Non',
                    confirmButtonText: 'Oui'
                }).then(

                    () => {

                        Fibsdd.delFibsdd(id).then(() => {
                            swal('Fibsdd supprimée', '', 'info', {allowOutsideClick: false}).then(
                                //remove div with id
                                () => {
                                    let div = document.getElementById(id);
                                    div.parentNode.removeChild(div);
                                }
                            )
                        })
                    },
                )
            }
        },

        async mounted() {

        }
    }
</script>

<style>

    #list-interventions .list-item{
        margin-bottom:0;
    }

    div.fi-item {
        display: flex;
        flex-direction: row;
        align-content: space-between;
        align-items: center;
        justify-content: center;
        background-color: #eee;
        margin-bottom: 10px;
    }

    a.btn.del-fi{
        width:40px;
        height:40px;
        margin-right:20px;
        background-color: #c31616;
        text-align:center;
    }

    a.btn.del-fi i {
        color: #ffffff;
        font-size: 2.2rem;
        text-align: center;
        left: 0;
        right: 0;
    }

</style>



// WEBPACK FOOTER //
// FibsddItem.vue?68abfe97